import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['12px', '12px'],
  middle: ['24px', '24px'],
  large: ['48px', '48px'],
};

const CollapseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80 80"
    width={sizes[props.size][0]}
    height={sizes[props.size][1]}
    style={{
      ...(props.shouldPadding
        ? {
            padding: '4px',
          }
        : {}),
    }}
  >
    <path
      fill="#8bb7f0"
      d="M48.5 31.5V9.207l7.888 7.888L70.776 2.707l6.517 6.517-14.388 14.388 7.888 7.888z"
    />
    <path
      fill="#4e7ab5"
      d="m70.776 3.414 5.81 5.81-13.681 13.681-.707.707.707.707L69.586 31H49V10.414l6.681 6.681.707.707.707-.707L70.776 3.414m0-1.414L56.388 16.388 48 8v24h24l-8.388-8.388L78 9.224 70.776 2z"
    />
    <path
      fill="#8bb7f0"
      d="m9.207 31.5 7.888-7.888L2.707 9.224l6.517-6.517 14.388 14.388L31.5 9.207V31.5z"
    />
    <path
      fill="#4e7ab5"
      d="m9.224 3.414 13.681 13.681.707.707.707-.707L31 10.414V31H10.414l6.681-6.681.707-.707-.707-.707L3.414 9.224l5.81-5.81m0-1.414L2 9.224l14.388 14.388L8 32h24V8l-8.388 8.388L9.224 2z"
    />
    <path
      fill="#8bb7f0"
      d="m2.707 70.776 14.388-14.388L9.207 48.5H31.5v22.293l-7.888-7.888L9.224 77.293z"
    />
    <path
      fill="#4e7ab5"
      d="M31 49v20.586l-6.681-6.681-.707-.707-.707.707L9.224 76.586l-5.81-5.81 13.681-13.681.707-.707-.707-.707L10.414 49H31m1-1H8l8.388 8.388L2 70.776 9.224 78l14.388-14.388L32 72V48z"
    />
    <path
      fill="#8bb7f0"
      d="M56.388 62.905 48.5 70.793V48.5h22.293l-7.888 7.888 14.388 14.388-6.517 6.517z"
    />
    <path
      fill="#4e7ab5"
      d="m69.586 49-6.681 6.681-.707.707.707.707 13.681 13.681-5.81 5.81-13.681-13.681-.707-.707-.707.707L49 69.586V49h20.586M72 48H48v24l8.388-8.388L70.776 78 78 70.776 63.612 56.388 72 48z"
    />
  </svg>
);
CollapseIcon.propTypes = {
  size: PropTypes.string,
  shouldPadding: PropTypes.bool,
};
CollapseIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
};

export default CollapseIcon;
